import { render } from "./SkeletonTable.vue?vue&type=template&id=1a203384&scoped=true"
import script from "./SkeletonTable.vue?vue&type=script&lang=js"
export * from "./SkeletonTable.vue?vue&type=script&lang=js"

import "./SkeletonTable.vue?vue&type=style&index=0&id=1a203384&scoped=true&lang=css"

import exportComponent from "C:\\projects\\dcc\\site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a203384"]])

export default __exports__